module.exports = __webpack_public_path__ + "static/img/white_paper-h5.ed9ac5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/white_paper-h5.png
// module id = 0U9Y
// module chunks = 34